import request from '@/plugins/axios'

// 保证金列表
export const apiEarnestLists = (params: any) => request.get('/deposit/lists', { params })

// 修改保证金
export const apiPutEarnest = (data: any) => request.post('/deposit/edit', data)

// 保证金列表
export const apidepositRecordLists = (params: any) => request.get('/depositRecord/lists', { params })
